import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import FavoriteIcon from '@icons/FavoriteIcon';
import { BodySmall, H4 } from '@styled';
import ShareIcon from '@icons/ShareIcon';
import getFavoriteHook from '@hooks/getFavoriteHook';

const ContainerOuter = styled.div`
    box-shadow: 0px 0px 7px rgba(87, 87, 87, 0.2);
    display: block;
    height: 100%;
    padding: 32px;
`;

const CompanyListItemRedesign = ({
    id,
    name,
    displayLocation,
    businessType,
    url,
    urlQuery,
    logoUrl,
    isFavorite: initialIsFavorite,
    showShareIcon = false,
    showFavoriteIcon = true,
    onClick = () => {},
}) => {
    const history = useHistory();

    // TODO: Use FavoriteButtonCompany
    const useFavorite = getFavoriteHook({ type: 'company', initialIsFavorite });
    const { isFavorite, isLoadingFavorite, saveFavorite, removeFavorite, setIsFavoriteManually } = useFavorite();

    useEffect(() => {
        setIsFavoriteManually(initialIsFavorite);
    }, [initialIsFavorite, setIsFavoriteManually]);

    let urlWithQuery = url;
    if (urlQuery) {
        urlWithQuery += `?${urlQuery}`;
    }

    const goToProfile = e => {
        // History is undefined if called from within a modal
        if (!history) {
            return;
        }

        e.preventDefault();
        history.push(urlWithQuery, { inApp: true });
    };

    const onFavorite = () => {
        if (isFavorite) {
            removeFavorite(id);
        } else {
            saveFavorite(id);
        }
    };

    return (
        <ContainerOuter>
            <div className="d-flex">
                <div className="my-0 pt-1">
                    <img src={logoUrl || '/assets/images/company-default.svg'} alt="" className="p-0 card-img-right" />
                </div>

                <div className="d-flex w-100">
                    <div className="ml-1.5rem w-100">
                        <H4 className="mb-0.5rem">
                            <a
                                href={urlWithQuery}
                                onClick={e => {
                                    onClick(urlWithQuery);
                                    goToProfile(e);
                                }}
                                onKeyDown={e => {
                                    onClick(urlWithQuery);
                                    goToProfile(e);
                                }}
                            >
                                {name}
                            </a>
                        </H4>

                        {businessType && businessType.length > 0 && (
                            <BodySmall className="text-dark-gray">{businessType[0]}</BodySmall>
                        )}

                        <BodySmall className="text-dark-gray">{displayLocation}</BodySmall>
                    </div>

                    <div>
                        <div className="d-flex align-items-center">
                            {showShareIcon && (
                                <div className="mr-1rem">
                                    <ShareIcon title={name} url={urlWithQuery} />
                                </div>
                            )}

                            {showFavoriteIcon && (
                                <FavoriteIcon
                                    id={id}
                                    type="company"
                                    isFavorite={isFavorite}
                                    onClick={onFavorite}
                                    isLoading={isLoadingFavorite}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </ContainerOuter>
    );
};

CompanyListItemRedesign.propTypes = {
    id: PropTypes.any.isRequired,
    name: PropTypes.string,
    displayLocation: PropTypes.string,
    businessType: PropTypes.array.isRequired,
    url: PropTypes.string,
    urlQuery: PropTypes.string,
    logoUrl: PropTypes.string,
    isFavorite: PropTypes.bool.isRequired,
    showShareIcon: PropTypes.bool,
    showFavoriteIcon: PropTypes.bool,
    onClick: PropTypes.func,
};

export default CompanyListItemRedesign;
